<template>
  <div class="home">
    <!-- 视频背景 - 暂时注释掉，等待视频文件 -->
    
    <video v-if="backgroundVideoUrl" class="video-background" autoplay muted loop playsinline>
      <source :src="backgroundVideoUrl" type="video/mp4">
    </video>
   

    <!-- 内容覆盖层 -->
    <div class="content-overlay">
      <div class="hero">
        <h1>{{ t('home.title') }}</h1>
        <p class="tagline">{{ t('home.tagline') }}</p>

        <div class="description">
          <p>{{ t('home.description') }}</p>
        </div>

        <div class="action-section">
          <BaseButton size="large" @click="$router.push('/auth')" v-if="!authStore.isAuthenticated">
            {{ t('home.start_experience') }}
          </BaseButton>
          <BaseButton size="large" @click="$router.push('/dashboard')" v-else>
            {{ t('home.enter_console') }}
          </BaseButton>
        </div>
      </div>
      
      <!-- ICP备案信息 -->
      <div class="icp-info">
        <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">
          沪ICP备2025143098号
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { BaseButton } from '@/components/base'
import { useAuthStore } from '@/stores/auth.js'
import { useI18n } from 'vue-i18n'

export default {
  name: 'HomeView',
  components: {
    BaseButton
  },
  setup() {
    const { t } = useI18n()
    const authStore = useAuthStore()
    const backgroundVideoUrl = '/video/background.mp4'

    return {
      t,
      authStore,
      backgroundVideoUrl
    }
  }
}
</script>

<style>
/* 全局样式：移除主页的容器限制 */
.main-content:has(.home) {
  padding: 0 !important;
  max-width: none !important;
  margin: 0 !important;
  width: 100% !important;
  height: 100vh !important;
}
</style>

<style scoped>
.home {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  margin: 0;
  padding: 0;
  /* 添加渐变背景作为视频背景的替代 */
  background: linear-gradient(135deg, 
    #667eea 0%, 
    #764ba2 25%, 
    #f093fb 50%, 
    #f5576c 75%, 
    #4facfe 100%);
  background-size: 400% 400%;
  animation: gradientShift 15s ease infinite;
}

/* 渐变动画 */
@keyframes gradientShift {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

/* 视频背景样式 */
.video-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: -1;
}

/* 内容覆盖层 */
.content-overlay {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  background: rgba(0, 0, 0, 0.4);
  /* 半透明遮罩提高文字可读性 */
}

.hero {
  max-width: 800px;
  margin: 0 auto;
  padding: var(--spacing-3xl) var(--spacing-lg);
}

.hero h1 {
  font-size: 4rem;
  color: white;
  margin-bottom: var(--spacing-lg);
  font-weight: 300;
  letter-spacing: -0.02em;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.7);
}

.tagline {
  font-size: 1.5rem;
  color: rgba(255, 255, 255, 0.9);
  margin-bottom: var(--spacing-xl);
  font-weight: 400;
  line-height: 1.4;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.7);
}

.description {
  margin-bottom: var(--spacing-3xl);
}

.description p {
  font-size: 1.125rem;
  color: rgba(255, 255, 255, 0.8);
  font-weight: 300;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.7);
}

.action-section {
  margin-top: var(--spacing-3xl);
}

/* 响应式设计 */
@media (max-width: 768px) {
  .hero {
    padding: var(--spacing-xl) var(--spacing-md);
  }

  .hero h1 {
    font-size: 3rem;
  }

  .tagline {
    font-size: 1.25rem;
  }

  .description p {
    font-size: 1rem;
  }
}

@media (max-width: 480px) {
  .hero h1 {
    font-size: 2.5rem;
  }

  .tagline {
    font-size: 1.125rem;
  }
}

/* ICP备案信息样式 */
.icp-info {
  position: absolute;
  bottom: var(--spacing-md);
  left: 50%;
  transform: translateX(-50%);
  z-index: 2;
}

.icp-info a {
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
  font-size: 0.875rem;
  transition: color 0.3s ease;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.7);
}

.icp-info a:hover {
  color: rgba(255, 255, 255, 0.9);
  text-decoration: underline;
}

@media (max-width: 768px) {
  .icp-info {
    bottom: var(--spacing-sm);
  }
  
  .icp-info a {
    font-size: 0.75rem;
  }
}
</style>
